module.exports = __webpack_public_path__ + "img/contextual-text-search.8125fa17.png";